import React from "react";

const SessionPageLeft = () => {
  return (
    <>
      <div className="sessionPageLeftContainer">
        <div className="sessionPageImageContainer">
          <div className="sessionPageOuterImage">
            <img
              src="https://storage.googleapis.com/twinleaves_bucket/pos_images/session-page-bg.jpg"
              height={"100%"}
              width={"100%"}
              style={{ borderBottomRightRadius: "16px", borderTopRightRadius: "16px" }}
            />
          </div>
          <div className="sessionPageInnerImage">
            <img
              src="https://storage.googleapis.com/twinleaves_bucket/pos_images/Lynx.png"
              height={"100%"}
              width={"100%"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SessionPageLeft;
